import { requestHandler } from "../lib/utils/network-client";

export function getEvents(params = {}) {
  return requestHandler("/events", {
    params
  });
}

export function createEvent(payload) {
  return requestHandler("/events", {
    method: "POST",
    body: payload
  });
}

export function updateEvent(id, payload) {
  return requestHandler(`/events/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteEvent(id) {
  return requestHandler(`/events/${id}`, {
    method: "DELETE"
  });
}
